import styled from 'styled-components';
import Card from '@components/card';
import { Link } from 'react-router-dom';

export const HomeBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 24px;
`;

export const HomeCategories = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    > div {
        width: 240px;
        height: 240px;
        margin: 20px;
    }
`;

export const SectionSeparator = styled.div`
    width: 100%;
    height: 1px;
    margin: 40px 0;
    background: linear-gradient(
        90deg,
        transparent,
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR},
        ${({ $isDarkMode }) =>
            $isDarkMode
                ? 'rgba(255, 255, 255, 0.4)'
                : 'rgba(0, 0, 0, 0.2)'},
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR},
        transparent
    );
`;

export const HomeCardWrapper = styled(Card)`
    display: flex;
`;

export const HomeCardTitle = styled.div`
    margin-top: 12px;
    font-size: 20px;
`;

export const HomeCardLink = styled(Link).attrs(
    ({ color }) => ({
        style: {
            color,
        },
    })
)`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-decoration: none;
`;
